import { Tracker } from "../helpers";
import { defaultLoadingBetCardHeight, telemetry } from "../constants";
import { createLegacyBet } from "./createLegacyBet";
export function createBetsChunks({ bets, chunkHeights, chunkSize, betCardData, setIsExpanded, shareBetHandler, currentFilter, }) {
    let chunkIndex = 0;
    return bets.length > 0
        ? bets.reduce((chunks, bet) => {
            const isExpandedRecord = betCardData.get(bet.betId);
            const isExpanded = typeof isExpandedRecord === "boolean"
                ? isExpandedRecord
                : false;
            if (chunks[chunkIndex].bets.length < chunkSize) {
                chunks[chunkIndex].bets = [...chunks[chunkIndex].bets, Object.assign(Object.assign({}, bet), { isExpanded, shareBet: () => {
                            Tracker.getInstance().trackEvent(telemetry.events.myBets, {
                                ClientType: telemetry.clientType,
                                Action: telemetry.actions.myBets.shareBet,
                                CurrentTab: currentFilter,
                                BetId: bet.betId,
                                BetStatus: bet.status,
                                MyBetsVersion: telemetry.version,
                            });
                            shareBetHandler(createLegacyBet(bet));
                        }, toggleIsExpanded: () => {
                            setIsExpanded(bet.betId);
                        } })];
                const height = chunkHeights.get(chunkIndex);
                if (typeof height === "number") {
                    chunks[chunkIndex].defaultHeight = height;
                }
                else {
                    chunks[chunkIndex].defaultHeight = chunks[chunkIndex].defaultHeight + defaultLoadingBetCardHeight;
                }
            }
            else {
                chunkIndex = chunkIndex + 1;
                chunks[chunkIndex] = {
                    bets: [Object.assign(Object.assign({}, bet), { isExpanded, shareBet: () => {
                                shareBetHandler(createLegacyBet(bet));
                            }, toggleIsExpanded: () => {
                                setIsExpanded(bet.betId);
                            } })],
                    defaultHeight: defaultLoadingBetCardHeight,
                };
            }
            return chunks;
        }, [{
                bets: [],
                defaultHeight: 0,
            }])
        : [];
}
//# sourceMappingURL=createBetsChunks.js.map